import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GetCurrentToken from './GetCurrentToken';

export default function ValidView(ViewAccess) {
    const navigate = useNavigate();
    const [allowWrite, setWrite] = useState(false);
    const [allowView, setViewer] = useState(false);
    const [userToken, setUserToken] = useState(false);

    useEffect(() => {
    
        let nameView = false;
    
        const {userToken, userTokenData} = GetCurrentToken();
    
        setUserToken(userToken);
        const userPermits = userTokenData.permissions;
        const filtered = userPermits.filter(validItem => validItem.includes(ViewAccess)); 
     
        if(filtered.length > 0){
          nameView = filtered[0].split('_');
          setViewer(true);
        } else {
          navigate("/");
        }
    
        if(nameView[1] === 'RW'){
          setWrite(true);
        } else {
          setWrite(false);
        }
     
      }, [navigate, ViewAccess]);

      return {allowWrite, allowView, userToken};
}

